import { ReviewProduct } from 'lib/reviews/types';
import { SliderWrapper } from '../SliderWrapper';
import { useTheme } from 'lib/context/ThemeContext';
import { ReviewsListTheme } from './ReviewsList.theme';
import ReviewProductImage from '../ReviewProductImage/ReviewProductImage';
import { Fragment } from 'react';
import { createUUID } from 'lib/utils/string-utils';

interface RenderReviewImageSliderProps {
  slidesData: ReviewProduct[];
  sliderSettings: { [key: string]: unknown };
}

const RenderReviewImageSlider: React.FC<RenderReviewImageSliderProps> = ({
  slidesData,
  sliderSettings,
}) => {
  const { themeData } = useTheme(ReviewsListTheme);

  if (!Array.isArray(slidesData)) {
    console.error('slidesData is not an array: ', slidesData);
    return <></>;
  }

  return (
    <SliderWrapper sliderSettings={sliderSettings}>
      {slidesData?.map((_product: ReviewProduct) => {
        return (
          <Fragment key={createUUID()}>
            <div className={themeData.classes.productSectionImageWrapper}>
              <ReviewProductImage productName={_product?.productName?.toLowerCase()} />
              <div className={themeData.classes.productSectionProductName}>
                {_product.displayName}
              </div>
            </div>
          </Fragment>
        );
      })}
    </SliderWrapper>
  );
};

export default RenderReviewImageSlider;
